export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
export const approach = (value, target, amount) => value < target ? Math.min(target, value + amount) : Math.max(target, value - amount);
export const lerp = (a, b, t) => a + (b - a) * t;
export const circleOverlap = (a, b) => (a.x - b.x) ** 2 + (a.y - b.y) ** 2 <= (a.r + b.r) ** 2;
export const radians = degrees => degrees * Math.PI / 180;
/** Seeded PRNG. Simulation and bots never use wall-clock time or Math.random(). */
export function random(seed) {
  let state = seed >>> 0 || 1;
  return () => { state ^= state << 13; state ^= state >>> 17; state ^= state << 5; return (state >>> 0) / 4294967296; };
}
